/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  Box,
  Container,
  Modal,
  Typography,
  styled,
  TableHead,
  Checkbox,
  Avatar,
  Button,
  Tooltip,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  IconButton,
  Collapse,
  useTheme
} from '@mui/material';
import useSWR from 'swr';

import { useTranslation } from 'react-i18next';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  accentColors,
  mainColors,
  secondaryColors,
  successColors,
  surfaceColors,
  textColors,
  themePalette,
  warningColors
} from '../../../theme/themeConfig';
import ImageViewer from '../../../components/ImageViewer';
import Api from '../../../api';
import {
  DrawerButton,
  ModalContainer
} from '../../../components/modals/GlobalConfirmModal';
import { TimeFormatEnum } from '../../../api-client/generated/api';
import {
  capitalizeString,
  downloadAll,
  getFormatedTimeByTimeZone,
  resourseColors,
  taskInteractionStyles,
  TaskStatus,
  TaskStyle
} from '../../../utils/general';
import TimeComponent from '../../../components/input/TimeComponent';
import ImageCarousel from './components/ImageCarousel';
import { getWorkedTimeAverageTime } from '../../../utils/calculatorHelper';
import useAuthStore from '../../../store/zustand/auth';
import Notes from '../Notes';
import useNavigationStore from '../../../store/zustand/navigation';
import ShowInformationIndicator from '../../../components/modals/ShowInformationIndicator';
import ProjectTaskDetails from './ProjectTaskDetails';
import useNotificationsStore from '../../../store/zustand/notifications';

const TaskImageListContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1.5),
  gridTemplateColumns: `repeat(auto-fill, minmax(${theme.spacing(7)}, 2fr))`,
  padding: theme.spacing(0.5)
}));

const ListHead = styled(TableHead)(({ theme }) => ({
  '.MuiTableHead-root': { boxShadow: 0 },
  display: 'flex',
  width: '100%'
}));

const ListTitle = styled(Typography)(({ theme }) => ({
  color: textColors.DARK_TEXT,
  fontFamily: 'Lexend',
  fontSize: '28px',
  fontWeight: '600',
  marginLeft: '1rem'
}));

const TaskImageContainer = styled(Box)(({ theme }) => ({
  '&:hover': {
    transform: 'scale(1.1)'
  },
  alignContent: 'center',
  alignItems: 'center',
  border: `1px solid ${theme.palette.secondary[100]}`,
  cursor: 'pointer',
  display: 'flex',
  height: theme.spacing(7),
  justifyContent: 'center',
  marginRight: '5px',
  overflow: 'hidden',
  transition: '1s ease',
  width: theme.spacing(7)
}));

interface IServiceTableBlockCheck {
  isCheked: boolean;
  text: string;
}

export interface NoteResponseDTO {
  createdAt: string;
  id: string;
  noteText: string;
  updatedAt: string;
  user: object;
}

interface IServiceTableBlock {
  checklist?: Array<IServiceTableBlockCheck> | [];
  images?: any;
  materials?: any;
  note?: any;
  taskIterationID?: any;
  title: string;
  type: string;
}
type VariantType = 'secondary-bold' | 'secondary';

interface IServiceTableRowTD {
  children?: any;
  colorH: string;
  fontSize: string;
  text?: string;
  typeTx?: VariantType;
  // width: number;
}

interface Props {
  calendarEvenState: string | undefined;
  dashboard: any;
  data: any;
  mutateAction: any;
  onlyTask: boolean;
  serviceInfo: any;
  setShowModal: (v: boolean) => void;
}

const ProjectTaskDetailsModal: React.FC<Props> =
  function ProjectTaskDetailsModal({
    calendarEvenState,
    dashboard,
    data,
    onlyTask,
    setShowModal,
    serviceInfo,
    mutateAction
  }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const { addNotification } = useNotificationsStore((state) => state);
    const [openRow, setOpenRow] = useState<number | null>(null);
    const { setConfirmModal } = useNavigationStore((state) => state);
    const [auxManualClose, setAuxManualClose] = useState<boolean>(true);
    const userState = useAuthStore((state) => state);
    const getTaskStyle = (task: TaskStatus): TaskStyle => {
      return taskInteractionStyles[task] || taskInteractionStyles.awaiting;
    };
    const [loading, setLoading] = useState<boolean>(false);

    const toggleRow = (index: number) => {
      if (openRow === index) {
        setOpenRow(null);
        return;
      }
      setOpenRow(index);
    };

    const showTaskIterationButton = () => {
      // Check if at least one task iteration exists and is not completed
      const hasIncompleteTaskIteration = data?.taskIteration?.some(
        (task: { status: string }) => task?.status !== 'completed'
      );
      // Show the button only if there is an incomplete task iteration
      return !!data?.taskIteration?.length && hasIncompleteTaskIteration;
    };

    const handleCompleteTask = async (index: number) => {
      try {
        if (
          !data.taskIteration[index].id ||
          !data.taskIteration[index].technician.id
        ) {
          throw new Error('Task iteration or technician not found');
        }

        setLoading(true);

        await Api.CalendarApi.patchTechnicianTaskManagenmentCloseTask({
          taskIterationId: data?.taskIteration[index].id,
          technicianId: data?.taskIteration[index].technician.id
        });

        mutateAction();
        addNotification(t('PROJECT.TOAST.SUCCESS'), 'success');

        setLoading(false);
        setShowModal(false);
      } catch (error: any) {
        addNotification(t('PROJECT.TOAST.FAIL'), 'error');

        setLoading(false);
      }
    };

    function GetCompleteTaskButton(index: number) {
      return (
        <Button
          onClick={() => {
            setConfirmModal(
              async () => {
                await handleCompleteTask(index);
              },
              `${t('GENERAL.confirmButton')}`,
              () => {},
              `${t('GENERAL.cancelButton')}`,
              <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                gap={2}
                justifyContent="center"
                pt={2}
                width={350}
              >
                <Typography variant="heading_500">
                  {t('PROJECT.TASKDETAILSMODAL.completeTask')}
                </Typography>

                <Typography sx={{ whiteSpace: 'pre-line' }} variant="body_300">
                  {t('PROJECT.TASKDETAILSMODAL.completeTaskDescription')}
                </Typography>
              </Box>
            );
          }}
          sx={{ maxWidth: '150px' }}
          variant="primary-text"
        >
          <Box alignItems="center" display="flex" gap="10px">
            <CircularProgress
              size={14}
              sx={{ display: loading ? 'block' : 'none' }}
            />
            <Typography fontSize="12px" variant="heading_328">
              {t('PROJECT.TASKDETAILSMODAL.completeTaskButton')}
            </Typography>
          </Box>
        </Button>
      );
    }

    function ServiceTableBlockCheck({
      isCheked,
      text
    }: IServiceTableBlockCheck) {
      return (
        <Box
          style={{
            alignContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start'
          }}
        >
          <Checkbox
            disabled
            checked={isCheked}
            onChange={() => {}}
            size="small"
          />
          <Typography
            align="left"
            style={{ color: '#4B4D56', fontSize: '12px' }}
          >
            {text}
          </Typography>
        </Box>
      );
    }

    function ServiceTableBlock({
      title,
      type,
      materials,
      taskIterationID,
      checklist,
      note,
      images
    }: IServiceTableBlock) {
      const [modalOpen, setModalOpen] = useState(false); // Estado para controlar si el modal está abierto
      const [selectedNote, setSelectedNote] = useState<NoteResponseDTO[]>([]);
      const [fireCreateNote, setFireCreateNote] = useState<boolean>(false);
      const [noteText, setNoteText] = useState<string>('');
      const [currentTaskDetails, setCurrentTaskDetails] = useState<any>({});
      const [imgData, setImgData] = useState('');
      const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);

      const { data: createTaskNoteData, error: createTaskNoteDataError } =
        useSWR(
          fireCreateNote && noteText !== '' && taskIterationID
            ? {
                entity: 'taskIteration',
                entityId: `${taskIterationID}`,
                noteText: `${noteText}`,
                taskIterationId: Number(taskIterationID) ?? 0
              }
            : null,
          Api.CalendarApi.noteCreate
        );

      // Función para manejar el clic en el icono de agregar
      const handleAddIconClick = (note: any) => {
        setSelectedNote(note); // Establece la nota seleccionada
        setModalOpen(true); // Abre el modal
      };

      useEffect(() => {
        if (createTaskNoteData && !createTaskNoteDataError) {
          const auxNotes = [...selectedNote, createTaskNoteData];
          setSelectedNote(auxNotes);
          setNoteText('');
          setFireCreateNote(false);
        }
      }, [createTaskNoteData, createTaskNoteDataError, selectedNote, noteText]);

      return (
        <Box>
          {type === 'materials' && (
            <Box style={{ padding: '12px' }}>
              {materials &&
                materials?.map((index: any, key: number) => (
                  <Typography
                    component="li"
                    key={key}
                    style={{
                      color: `${secondaryColors.SECONDARY_5}`,
                      fontSize: '12px'
                    }}
                    variant="secondary"
                  >
                    {index?.name}
                  </Typography>
                ))}
            </Box>
          )}

          {type === 'note' && (
            <>
              <Box>
                <Box
                  style={{
                    display: 'flex'
                  }}
                >
                  {calendarEvenState !== 'Created' && (
                    <Box display="flex" flexDirection="column">
                      <Typography
                        color={`${secondaryColors.SECONDARY}`}
                        fontSize={12}
                        variant="secondary"
                      >
                        {/* Todo: translation... */}
                        Notes
                      </Typography>
                      <Box
                        alignItems="center"
                        display="flex"
                        gap={theme.spacing(2)}
                        justifyContent="center"
                      >
                        <Typography
                          color={`${textColors.BLACK}`}
                          fontSize={12}
                          variant="secondary"
                        >{`${note?.length ?? 0}`}</Typography>
                        <IconButton
                          aria-label="view notes"
                          onClick={() => handleAddIconClick(note)}
                          size="small"
                          sx={{ height: '20px', width: '20px' }}
                        >
                          <VisibilityOutlinedIcon
                            color="primary"
                            sx={{ height: '20px', width: '20px' }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box>
                {modalOpen && (
                  <Modal
                    onClose={() => {
                      setModalOpen(false);
                    }}
                    open={modalOpen}
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: surfaceColors.SURFACE_6,
                        borderRadius: 2,
                        height: 600,
                        padding: '32px 32px 16px 32px',
                        width: 800
                      }}
                    >
                      <Notes
                        hideDeleteButton
                        technicianNotes
                        entity="taskIteration"
                        id={taskIterationID}
                      />
                    </Box>
                  </Modal>
                )}
              </Box>
            </>
          )}

          {type === 'checklist' && (
            <Box>
              {checklist &&
                checklist?.map((index: any, key: number) => {
                  return (
                    <ServiceTableBlockCheck
                      isCheked={index?.checked}
                      key={key}
                      text={index?.name}
                    />
                  );
                })}
            </Box>
          )}

          {type === 'images' && (
            <Box display="flex" flexDirection="column">
              <Typography
                color={`${secondaryColors.SECONDARY}`}
                fontSize={12}
                variant="secondary"
              >
                Images
              </Typography>
              <Typography
                color={`${textColors.BLACK}`}
                fontSize={12}
                variant="secondary"
              >{`${images.length ?? 0}`}</Typography>

              {/* Todo: Move to collapsed view... */}
              {/*
              <ImageCarousel
                images={images}
                openViewer={setIsImageViewerOpen}
                setImageUrlViewer={setImgData}
              /> */}
              {/* <TaskImageListContainer>
                {images.map((image: any, key: number) => {
                  return (
                    <Box
                      style={{
                        alignContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start'
                      }}
                    >
                      <TaskImageContainer
                        onClick={() => {
                          setIsImageViewerOpen(true);
                          setImgData(image?.large || image?.fileUrl);
                        }}
                      >
                        <img
                          alt={image.fileName}
                          key={`taskIteration-image-${image.id}}`}
                          src={image.small || image.fileUrl}
                        />
                      </TaskImageContainer>
                    </Box>
                  );
                })}
              </TaskImageListContainer> */}
              {/* Move to collapsed view... */}
              {/* <Box>
                {isImageViewerOpen && imgData !== '' && (
                  <ImageViewer
                    isOpen={isImageViewerOpen}
                    setIsOpen={setIsImageViewerOpen}
                    url={imgData}
                  />
                )}
              </Box> */}
            </Box>
          )}
        </Box>
      );
    }

    function ServiceTableRowTD({
      fontSize,
      colorH,
      typeTx,
      text,
      children
    }: IServiceTableRowTD) {
      return (
        <Box
          style={{
            // border: 'solid 0.1px rgba(203, 204, 211, 0.7)',
            // color: `${secondaryColors.SECONDARY}`,
            height: '100%'
            // width: `${width}%`
          }}
        >
          <Typography color={colorH} fontSize={fontSize} variant={typeTx}>
            {text}
            {children}
          </Typography>
        </Box>
      );
    }

    // Note: unused in Feb. 2025 redesign...
    function ServiceTableHeader() {
      return (
        <TableRow>
          <TableCell align="center" colSpan={0} width={120}>
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="TECHNICIAN"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={70}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="ESTIMATED TIME"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={70}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="STATUS"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={140}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="CHECKLIST"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={80}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="TIME"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={140}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="GEOFENCING"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px' }}
            width={140}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="IMAGES"
              typeTx="secondary-bold"
            />
          </TableCell>
          <TableCell
            align="center"
            colSpan={0}
            sx={{ padding: '5px', width: '120px' }}
          >
            <ServiceTableRowTD
              colorH={`${themePalette.TITLE}`}
              fontSize="12px"
              text="NOTES"
              typeTx="secondary-bold"
            />
          </TableCell>
          {showTaskIterationButton() && (
            <TableCell
              align="center"
              colSpan={0}
              sx={{ padding: '5px', width: '150px' }}
            >
              <ServiceTableRowTD
                colorH={`${themePalette.TITLE}`}
                fontSize="12px"
                text=""
                typeTx="secondary-bold"
              />
            </TableCell>
          )}
        </TableRow>
      );
    }

    const sumWorkedTime =
      data?.taskIteration?.length > 0
        ? getWorkedTimeAverageTime(data?.taskIteration)
        : 0;

    return (
      <Modal
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
        onClose={() => {
          setShowModal(false);
        }}
        open={auxManualClose}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ModalContainer
          sx={{
            '@media (min-width: 600px)': {
              minWidth: '700px'
            },
            alignItems: 'stretch',
            maxHeight: '90vh',
            maxWidth: '960px',
            overflowY: 'auto',
            padding: 0,
            textAlign: 'left',
            width: '95%'
          }}
        >
          {/* Modal header */}
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: '#005DA2',
              borderRadius: '8px 8px 0 0',
              display: 'flex',
              gap: 2,
              justifyContent: 'space-between',
              px: 3,
              py: '14px',
              width: '100%'
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '15px',
                  fontWeight: 700,
                  lineHeight: '22px'
                }}
              >
                {data.name} — {t('PROJECT.TASKDETAILSMODAL.details')}
              </Typography>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: 2,
                  mt: '4px'
                }}
              >
                <Box sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}>
                  <Typography
                    sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px' }}
                  >
                    Estimated
                  </Typography>
                  <Typography
                    sx={{ color: '#fff', fontSize: '12px', fontWeight: 600 }}
                  >
                    <TimeComponent
                      readOnly
                      setTime={() => {}}
                      time={
                        data.totalTimeInHours /
                          (data?.technicians.length || 1) || 0.0
                      }
                    />
                  </Typography>
                </Box>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}>
                  <Typography
                    sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px' }}
                  >
                    Worked
                  </Typography>
                  <Typography
                    sx={{ color: '#90D4CE', fontSize: '12px', fontWeight: 600 }}
                  >
                    <TimeComponent
                      readOnly
                      setTime={() => {}}
                      time={sumWorkedTime / 60 || 0.0}
                    />
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Button
              onClick={() => setShowModal(false)}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  color: '#fff'
                },
                color: 'rgba(255,255,255,0.8)',
                minWidth: 0,
                padding: '4px'
              }}
            >
              <i className="custom-icon icon-close" style={{ fontSize: 16 }} />
            </Button>
          </Box>

          {/* Table content */}
          <Box sx={{ p: 2, width: '100%' }}>
            <TableContainer
              sx={{
                border: '1px solid #E2E4EA',
                borderRadius: '8px',
                maxHeight: '65vh',
                overflowY: 'auto'
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {[
                      'TECHNICIAN',
                      'EST.',
                      'STATUS / WORKED',
                      'START · END',
                      'CHECKLIST',
                      'GEO',
                      'IMGS',
                      'NOTES',
                      ''
                    ].map((col) => (
                      <TableCell
                        key={col}
                        sx={{
                          backgroundColor: '#F5F6F8',
                          borderColor: '#E2E4EA',
                          color: '#7D8090',
                          fontSize: '10px',
                          fontWeight: 700,
                          letterSpacing: '0.06em',
                          padding: '6px 8px',
                          textTransform: 'uppercase',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.technicians?.map((technician: any, index: any) => {
                    const auxName =
                      technician?.name ||
                      `${technician.firstName} ${technician.lastName}`;
                    const initials = auxName
                      ?.split(' ')
                      ?.slice(0, 2)
                      ?.map((word: string) => word[0]?.toUpperCase())
                      ?.join('');
                    const auxKey = `detail-project-team-${technician.id}`;
                    const iteration =
                      data?.taskIteration?.find(
                        (taskIte: any) =>
                          taskIte.technician.id === technician.id
                      ) || null;
                    const taskIterationTechnician = [
                      {
                        closedBy: iteration?.closedBy,
                        closer: iteration?.closer,
                        startedBy: iteration?.startedBy,
                        starter: iteration?.starter,
                        technician: iteration?.technician
                      }
                    ];

                    return (
                      <>
                        <TableRow
                          key={auxKey}
                          sx={{
                            '&:hover': { backgroundColor: '#FAFBFC' },
                            backgroundColor:
                              openRow === index ? '#F5F6F8' : 'transparent'
                          }}
                        >
                          {/* Technician */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px 12px',
                              width: 180
                            }}
                          >
                            <Box
                              sx={{
                                alignItems: 'center',
                                display: 'flex',
                                gap: 1
                              }}
                            >
                              {initials && (
                                <Tooltip arrow title={auxName}>
                                  <Avatar
                                    alt={auxName}
                                    sx={{
                                      backgroundColor: resourseColors[index],
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      height: 28,
                                      width: 28
                                    }}
                                  >
                                    {technician.profilePic ? null : initials}
                                  </Avatar>
                                </Tooltip>
                              )}
                              <Typography
                                sx={{
                                  color: '#4B4D56',
                                  fontSize: '12px',
                                  fontWeight: 500
                                }}
                              >
                                {auxName}
                              </Typography>
                              {technician.isPartnerProxy && (
                                <Typography
                                  sx={{
                                    background: mainColors.MAIN_LIGHT,
                                    borderRadius: '10px',
                                    color: mainColors.MAIN,
                                    fontSize: '9px',
                                    fontWeight: 600,
                                    ml: 0.5,
                                    px: '6px',
                                    py: '1px'
                                  }}
                                >
                                  Partner
                                </Typography>
                              )}
                            </Box>
                          </TableCell>

                          {/* Est. time */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 80
                            }}
                          >
                            <Typography
                              sx={{ color: '#7D8090', fontSize: '11px' }}
                            >
                              <TimeComponent
                                readOnly
                                short
                                containerProps={{ gap: 0 }}
                                setTime={() => {}}
                                time={
                                  data.totalTimeInHours /
                                    (data?.technicians.length || 1) || 0.0
                                }
                              />
                            </Typography>
                          </TableCell>

                          {/* Status */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 120
                            }}
                          >
                            <Box
                              sx={{
                                alignItems: 'center',
                                display: 'flex',
                                gap: 1
                              }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: getTaskStyle(
                                    !iteration?.status
                                      ? 'awaiting'
                                      : iteration?.status
                                  )?.backgroundColor,
                                  border: `1px solid ${
                                    getTaskStyle(
                                      !iteration?.status
                                        ? 'awaiting'
                                        : iteration?.status
                                    )?.borderColor
                                  }`,
                                  borderRadius: '20px',
                                  display: 'inline-flex',
                                  px: '10px',
                                  py: '2px'
                                }}
                              >
                                {iteration &&
                                iteration?.status === 'completed' &&
                                iteration?.workedTime ? (
                                  <Typography
                                    sx={{
                                      color: getTaskStyle(iteration?.status)
                                        .textColor,
                                      fontSize: '11px'
                                    }}
                                  >
                                    <TimeComponent
                                      readOnly
                                      short
                                      containerProps={{ gap: 0 }}
                                      setTime={() => {}}
                                      time={
                                        parseFloat(iteration.workedTime) / 60 ||
                                        0.0
                                      }
                                    />
                                  </Typography>
                                ) : (
                                  <Typography
                                    sx={{
                                      color: getTaskStyle(
                                        !iteration?.status
                                          ? 'awaiting'
                                          : iteration?.status
                                      ).textColor,
                                      fontSize: '11px',
                                      fontWeight: 600
                                    }}
                                  >
                                    {!iteration ||
                                    iteration?.status === 'created'
                                      ? 'Awaiting'
                                      : capitalizeString(
                                          !iteration?.status
                                            ? 'awaiting'
                                            : iteration?.status === 'inProgress'
                                              ? 'In Progress'
                                              : iteration?.status
                                        )}
                                  </Typography>
                                )}
                              </Box>
                              {iteration?.approvalStatus ===
                                'ApprovalRequired' && (
                                <Tooltip
                                  title={t(
                                    'TOOLTIP.PROJECT.taskApprovalRequired'
                                  )}
                                >
                                  <i
                                    className="custom-icon icon-warning"
                                    style={{ color: '#E79137', fontSize: 14 }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>

                          {/* Times */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 140
                            }}
                          >
                            {iteration?.startTime ? (
                              <Box>
                                <Typography
                                  sx={{ color: '#7D8090', fontSize: '11px' }}
                                >
                                  Start:{' '}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: '#4B4D56',
                                      fontSize: '11px',
                                      fontWeight: 600
                                    }}
                                  >
                                    {getFormatedTimeByTimeZone(
                                      iteration?.startTime,
                                      0,
                                      userState.timeFormat ===
                                        TimeFormatEnum._24h
                                    )}
                                  </Typography>
                                </Typography>
                                {iteration?.endTime && (
                                  <Typography
                                    sx={{
                                      color: '#7D8090',
                                      fontSize: '11px',
                                      mt: '2px'
                                    }}
                                  >
                                    End:{' '}
                                    <Typography
                                      component="span"
                                      sx={{
                                        color: '#4B4D56',
                                        fontSize: '11px',
                                        fontWeight: 600
                                      }}
                                    >
                                      {getFormatedTimeByTimeZone(
                                        iteration?.endTime,
                                        0,
                                        userState.timeFormat ===
                                          TimeFormatEnum._24h
                                      )}
                                    </Typography>
                                  </Typography>
                                )}
                              </Box>
                            ) : (
                              <Typography
                                sx={{ color: '#CBCCD3', fontSize: '11px' }}
                              >
                                —
                              </Typography>
                            )}
                          </TableCell>

                          {/* Checklist */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 72
                            }}
                          >
                            {iteration?.checkList ? (
                              (() => {
                                const checked = iteration.checkList.filter(
                                  (i: any) => i.checked
                                ).length;
                                const total = iteration.checkList.length;
                                return (
                                  <Box
                                    sx={{
                                      alignItems: 'center',
                                      display: 'flex',
                                      gap: '4px'
                                    }}
                                  >
                                    <i
                                      className="custom-icon icon-checklist"
                                      style={{
                                        color:
                                          checked === total && total > 0
                                            ? '#189A90'
                                            : '#7D8090',
                                        fontSize: 14
                                      }}
                                    />
                                    <Typography
                                      sx={{
                                        color:
                                          checked === total && total > 0
                                            ? '#189A90'
                                            : '#4B4D56',
                                        fontSize: '11px',
                                        fontWeight: 600
                                      }}
                                    >
                                      {checked}/{total}
                                    </Typography>
                                  </Box>
                                );
                              })()
                            ) : (
                              <Typography
                                sx={{ color: '#CBCCD3', fontSize: '11px' }}
                              >
                                —
                              </Typography>
                            )}
                          </TableCell>

                          {/* Geo */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 48
                            }}
                          >
                            {iteration ? (
                              <i
                                className="custom-icon icon-location"
                                style={{
                                  color:
                                    iteration?.geofencingApproved === true
                                      ? '#189A90'
                                      : iteration?.geofencingApproved === false
                                        ? '#E79137'
                                        : '#CBCCD3',
                                  fontSize: 16
                                }}
                              />
                            ) : (
                              <Typography
                                sx={{ color: '#CBCCD3', fontSize: '11px' }}
                              >
                                —
                              </Typography>
                            )}
                          </TableCell>

                          {/* Images */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 80
                            }}
                          >
                            {iteration && (
                              <Box
                                sx={{
                                  alignItems: 'center',
                                  display: 'flex',
                                  gap: '4px',
                                  justifyContent: 'center'
                                }}
                              >
                                <i
                                  className="custom-icon icon-photo-upload"
                                  style={{
                                    color:
                                      iteration?.fileBank?.length > 0
                                        ? '#005DA2'
                                        : '#CBCCD3',
                                    fontSize: 15
                                  }}
                                />
                                {iteration?.fileBank?.length > 0 && (
                                  <Typography
                                    sx={{
                                      color: '#005DA2',
                                      fontSize: '11px',
                                      fontWeight: 600
                                    }}
                                  >
                                    {iteration.fileBank.length}
                                  </Typography>
                                )}
                              </Box>
                            )}
                          </TableCell>

                          {/* Notes */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 80
                            }}
                          >
                            {iteration && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center'
                                }}
                              >
                                <i
                                  className="custom-icon icon-eye"
                                  style={{
                                    color:
                                      iteration?.notes?.length > 0
                                        ? '#189A90'
                                        : '#CBCCD3',
                                    cursor:
                                      iteration?.notes?.length > 0
                                        ? 'pointer'
                                        : 'default',
                                    fontSize: 16
                                  }}
                                  title={
                                    iteration?.notes?.length > 0
                                      ? `${iteration.notes.length} note${
                                          iteration.notes.length !== 1
                                            ? 's'
                                            : ''
                                        }`
                                      : 'No notes'
                                  }
                                />
                              </Box>
                            )}
                          </TableCell>

                          {/* Expand */}
                          <TableCell
                            sx={{
                              borderColor: '#F0F1F3',
                              padding: '8px',
                              width: 48
                            }}
                          >
                            {iteration && (
                              <IconButton
                                aria-label="expand row"
                                onClick={() => toggleRow(index)}
                                size="small"
                                sx={{
                                  border: '1px solid #E2E4EA',
                                  borderRadius: '6px',
                                  height: 28,
                                  padding: '2px',
                                  width: 28
                                }}
                              >
                                {openRow === index ? (
                                  <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                                ) : (
                                  <KeyboardArrowDownIcon
                                    sx={{ fontSize: 16 }}
                                  />
                                )}
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>

                        {/* Expanded details row */}
                        <TableRow>
                          <TableCell
                            colSpan={9}
                            sx={{
                              borderColor: '#F0F1F3',
                              paddingBottom: 0,
                              paddingTop: 0
                            }}
                          >
                            <Collapse
                              unmountOnExit
                              in={openRow === index}
                              timeout="auto"
                            >
                              <Box sx={{ py: 1 }}>
                                <ProjectTaskDetails
                                  callBack={() => {
                                    mutateAction();
                                    setShowModal(false);
                                  }}
                                  iteration={iteration}
                                  technician={technician}
                                />
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </ModalContainer>
      </Modal>
    );
  };

export default ProjectTaskDetailsModal;
